import { Module } from 'vuex'
import RootStateTypes from '../../interface'
import { XTXObject, XTXPram, UkeyUserInfo } from './XTXScoket';

const XTXModel: Module<XTXObject, RootStateTypes> = {
    namespaced: true,
    state: {
        xtxScoket: null,
        count: 0,
        curUserCertId: "",
        ukeyList: Array<UkeyUserInfo>(),
    },
    mutations: {
        initWebsocket(state) {
            // 如果已存在连接，先关闭
            if (state.xtxScoket != null) {
                try {
                    if (state.xtxScoket.readyState === WebSocket.OPEN || state.xtxScoket.readyState === WebSocket.CONNECTING) {
                        state.xtxScoket.close();
                    }
                } catch (e) {
                    console.warn('关闭旧连接时出错:', e);
                }
                state.xtxScoket = null;
            }

            const wsUrl = "ws://127.0.0.1:21051/xtxapp/";
            const wssUrl = "wss://127.0.0.1:21061/xtxapp/";
            var isDesktopApp = navigator.userAgent.indexOf('VBiddingDesktop') > -1;

            // 连接成功后的回调绑定
            function bindSocket(state: any, socket: WebSocket, url: string) {
                state.xtxScoket = socket;
                socket.onopen = function () {
                    console.log('WebSocket连接成功:', url);
                };
                socket.onerror = function (error) {
                    console.error('WebSocket连接错误:', error);
                    console.log('通讯异常,请检查证书助手环境');
                    setTimeout(() => {
                        if (state.xtxScoket && state.xtxScoket.readyState !== WebSocket.OPEN) {
                            state.xtxScoket = null;
                        }
                    }, 100);
                };
                socket.onclose = function (event: any) {
                    console.log('WebSocket连接已断开:', event.code, event.reason);
                    state.xtxScoket = null;
                };
            }

            // 桌面客户端或非HTTPS：直接用ws
            if (isDesktopApp || 'https:' !== document.location.protocol) {
                try {
                    const socket = new WebSocket(wsUrl);
                    bindSocket(state, socket, wsUrl);
                } catch (error) {
                    console.error('创建WebSocket连接失败:', error);
                    state.xtxScoket = null;
                }
            } else {
                // HTTPS环境：先尝试wss，失败后回退到ws
                try {
                    const wssSocket = new WebSocket(wssUrl);
                    let settled = false;

                    wssSocket.onopen = function () {
                        if (settled) return;
                        settled = true;
                        console.log('WebSocket(wss)连接成功:', wssUrl);
                        bindSocket(state, wssSocket, wssUrl);
                    };

                    wssSocket.onerror = function () {
                        if (settled) return;
                        settled = true;
                        console.warn('wss连接失败，尝试ws回退...');
                        try { wssSocket.close(); } catch (e) { /* ignore */ }
                        // 回退到ws
                        try {
                            const wsSocket = new WebSocket(wsUrl);
                            bindSocket(state, wsSocket, wsUrl);
                        } catch (error) {
                            console.error('ws回退连接也失败:', error);
                            state.xtxScoket = null;
                        }
                    };

                    wssSocket.onclose = function (event: any) {
                        if (!settled) {
                            settled = true;
                            console.warn('wss连接关闭，尝试ws回退...');
                            try {
                                const wsSocket = new WebSocket(wsUrl);
                                bindSocket(state, wsSocket, wsUrl);
                            } catch (error) {
                                console.error('ws回退连接也失败:', error);
                                state.xtxScoket = null;
                            }
                        }
                        // settled=true 时 wssSocket 已被主动关闭（onerror 回退流程），
                        // state.xtxScoket 此时已指向 ws 回退 socket，不能置 null
                    };
                } catch (error) {
                    console.error('创建wss连接失败，尝试ws:', error);
                    try {
                        const wsSocket = new WebSocket(wsUrl);
                        bindSocket(state, wsSocket, wsUrl);
                    } catch (e) {
                        console.error('ws回退连接也失败:', e);
                        state.xtxScoket = null;
                    }
                }
            }

        },
        webSocketCall(state, xtxPram: XTXPram) {
            if (state.xtxScoket == null) {
                return;
            }
            var sendArray = {
                'call_cmd_id': xtxPram.callCmdId,
                'CLSID': xtxPram.clsid,
                'xtx_func_name': xtxPram.methodName,
                'func': xtxPram.methodName,
                'param': xtxPram.argsArray,
                'URL': window.location.href
            };

            if (state.xtxScoket.readyState == WebSocket.OPEN) {
                var s = JSON.stringify(sendArray);
                console.log(s);
                state.xtxScoket.send(JSON.stringify(sendArray));
            } else {
                console.log("错误！无法连接到 WebSocket server：[" + state.xtxScoket.url + "]!!!WebSocket 状态码:" + state.xtxScoket.readyState);
            }
        },
        setUserList(state, val) {
            state.ukeyList = val;
        },
        setCurUserCertId(state, val) {
            state.curUserCertId = val;
        }
    },
    actions: {
        initWebsocket(context: any) {
            context.commit('initWebsocket')
        },
        webSocketCall(context: any, xtxPram: XTXPram) {
            context.commit('webSocketCall', xtxPram)
        },
        setUserList(context: any, val) {
            context.commit('setUserList', val)
        }
        ,
        setCurUserCertId(context: any, val) {
            context.commit('setCurUserCertId', val)
        }
    }

}
export default XTXModel;